// extracted by mini-css-extract-plugin
module.exports = {"highlight":"Q5MRtN2dqzLYIfuQS4udd"};